import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { map } from 'rxjs/operators'
import { ContactsService } from '../../../api'
import { HeadlessView } from '../../../common/shared/components/headless-view';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateMessageService } from '../create-message.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericErrorHandlerService } from '../../../core/services/generic-error-handler.service';
import { NotificationService } from '../../../common/layout/notification.service';
import { UserService } from '../../../core/services/user.service';

@Component({
    selector: 'ns-send-message',
    templateUrl: './send-message.component.html',
    styleUrls: ['./send-message.component.scss']
})
export class SendMessageComponent extends HeadlessView implements OnInit {

    public documents;
    public myDocuments;
    public allContacts;
    public contacts$;
    public selectedDocuments;
    public selectedMakes;

    public hasSelectedMyDocuments: boolean = false;
    public isCustomMessageEnabled: boolean = false;

    public form: FormGroup;
    public addressesFormArray: FormArray;
    public userName = '';
    public phone = '';
    public email = '';

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private activatedRoute: ActivatedRoute,
        private changeDetectorRef: ChangeDetectorRef,
        private createMessageService: CreateMessageService,
        private router: Router,
        private formBuilder: FormBuilder,
        private genericErrorHandlerService: GenericErrorHandlerService,
        private notificationService: NotificationService,
        private userService: UserService,
        private contactsService: ContactsService,
    ) {
        super(layoutService, mobileDetectorService);
        this.layoutService.disableFooter();

        this.documents = activatedRoute.snapshot.data['documents'];
        this.myDocuments = activatedRoute.snapshot.data['myDocuments'];
        this.allContacts = activatedRoute.snapshot.data['contacts'].data.map(contact => ({
            ...contact,
            name: `${contact.firstName} ${contact.lastName}`
        }));

        this.selectedDocuments = createMessageService.getDocumentsSelection();
        this.selectedMakes = createMessageService.getMakesSelection();
        this.checkSelectedMyDocuments();

        this.form = formBuilder.group({
            customMessage: [''],
            addresses: formBuilder.array([])
        });

        this.addressesFormArray = this.form.get('addresses') as FormArray;
        this.addAddress();

        this.userName = this.userService.user.name;
        this.phone = this.userService.user.phone;
        this.email = this.userService.user.email;

    }

    ngOnInit(): void {
    }

    afterViewInit(): void {
        this.changeDetectorRef.detectChanges()
    }

    public onGoBack() {
        this.router.navigate(['..', 'wybierz-dokumenty'], { relativeTo: this.activatedRoute });
    }
    public onNext() {
        this.genericErrorHandlerService.showErrors(this.form);

        this.form.updateValueAndValidity();

        if (!Object.keys(this.selectedDocuments).length) {
            this.notificationService.error('Wybierz 1 lub więcej dokumentów');
            return;
        }

        if (this.form.valid) {
            this.createMessageService.sendMessage(
                this.form.getRawValue().addresses.map(item => item.address).flat(),
                this.form.value.customMessage,
            ).then(() => {
                this.router.navigate(['/']);
            });
        }

    }

    public addAddress() {
        this.addressesFormArray.push(
            this.formBuilder.group({
                address: [null, Validators.required]
            })
        );
    }

    public removeAddress(index) {
        this.addressesFormArray.removeAt(index);
    }

    public hasDocumentsForMake(group) {
        if (group && group.documents && group.documents.length) {
            for (let i = 0; i < group.documents.length; i++) {
                if (this.selectedDocuments[group.documents[i].id]) {
                    return true;
                }
            }
        }

        return false;
    }

    private checkSelectedMyDocuments() {
        let result = false;

        this.myDocuments.data.forEach(item => {
            if (this.selectedDocuments['MYDOC_' + item.id]) {
                result = true;
            }
        });

        this.hasSelectedMyDocuments = result;
    }

    addCustomText(): void {
        this.isCustomMessageEnabled = true;
    }

    handleFilterChange(event: any): void {
        this.contacts$ = this.contactsService.contactListQuery(null, null, event)
          .pipe(
            map(res => res.data.map(contact => ({
                ...contact,
                name: `${contact.firstName} ${contact.lastName}`
            })))
          )
    }
}
